import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
    {
        path: '/storageelements',
        name: 'StorageElementView',
        component: () => import(/* webpackChunkName: "storage-element-view" */ '@/modules/warehouse/components/elements/StorageElementsView'),
        meta: {
            moduleId: 'storageelements',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/storageelements/:id',
        name: 'StorageElementsForm',
        component: () => import(/* webpackChunkName: "storage-types-form" */ '@/modules/warehouse/components/elements/StorageElementsForm'),
        meta: {
            preloads: ['rights/actingUserHasRight/WORK_Lagerverwaltung_Organisation'],
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/storageorganizationtypes',
        name: 'StorageOrganisationTypesView',
        component: () => import(/* webpackChunkName: "storage-types-view" */ '@/modules/warehouse/components/types/StorageOrganisationTypesView'),
        meta: {
            moduleId: 'storageorganizationtypes',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],

        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/storageorganizationtypes/:id',
        name: 'StorageOrganisationTypesForm',
        component: () => import(/* webpackChunkName: "storage-types-form" */ '@/modules/warehouse/components/types/StorageOrganisationTypesForm'),
        meta: {
            preloads: ['rights/actingUserHasRight/WORK_Lagerverwaltung_Organisation'],
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/storageelementstock',
        name: 'StockView',
        component: () => import(/* webpackChunkName: "stock-view" */ '@/modules/warehouse/components/productstock/StockView'),
        meta: {
            moduleId: 'storageelementstock',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/storageelementstock/:id',
        name: 'StockForm',
        component: () => import(/* webpackChunkName: "stock-form" */ '@/modules/warehouse/components/productstock/StockForm'),
        meta: {
            preloads: ['configurations/storage'],
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/storageOrders',
        name: 'StorageOrder',
        component: () => import(/* webpackChunkName: "storage-orders-view" */ '@/modules/warehouse/components/storage_orders/StorageOrdersView'),
        meta: {
            moduleId: 'storageOrders',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/stocktaking',
        name: 'StocktakingView',
        component: () => import(/* webpackChunkName: "stocktaking-view" */ '@/modules/warehouse/components/inventory/StocktakingView'),
        meta: {
            moduleId: 'stocktaking',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/stocktaking/:id',
        name: 'StocktakingForm',
        component: () => import(/* webpackChunkName: "stocktaking-form" */ '@/modules/warehouse/components/inventory/StocktakingForm'),
        meta: {
            preloads: [
              'rights/actingUserHasRight/WORK_Lagerverwaltung_Inventur_abschliessen', 
              'rights/actingUserHasRight/WORK_Lagerverwaltung_Inventur'
            ],
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/stockmovement',
        name: 'StockMovementsMobileNoProject',
        component: () => import(/* webpackChunkName: "stockmovements-mobile" */ '@/modules/stockmovements_mobile/StockMovementsMobile'),
        meta: {
            // moduleId: 'inventories',
            ignoreModuleCheck: true,
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/stockmovement/project/:projectId',
        name: 'StockMovementsMobile',
        component: () => import(/* webpackChunkName: "stockmovements-mobile" */ '@/modules/stockmovements_mobile/StockMovementsMobile'),
        meta: {
            // moduleId: 'inventories',
            ignoreModuleCheck: true,
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/stockmovement/arrivalofgoods/:id',
        name: 'StockMovementsMobileDeposit',
        component: () => import(/* webpackChunkName: "stockmovements-mobile" */ '@/modules/stockmovements_mobile/StockMovementsMobileDeposit'),
        meta: {
            moduleId: 'stockmovement',
            ignoreModuleCheck: true,
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/orders',
        name: 'OrdersView',
        component: () => import(/* webpackChunkName: "orders-view" */ '@/modules/warehouse/components/orders/OrdersView'),
        meta: {
            moduleId: 'orders',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/externalDemands',
        name: 'ExternalDemandsView',
        component: () => import(/* webpackChunkName: "external-demands-view" */ '@/modules/warehouse/components/order_suggestions/ExternalDemandsView'),
        meta: {
            moduleId: 'externalDemands',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
            preloads: ['rights/actingUserHasRight/WORK_Lagerverwaltung_Bestellungen'],
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/internalDemands',
        name: 'InternalDemandsView',
        component: () => import(/* webpackChunkName: "internal-demands-view" */ '@/modules/warehouse/components/internal_procurements/InternalDemandsView'),
        meta: {
            moduleId: 'internalDemands',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
            preloads: ['rights/actingUserHasRight/WORK_Lagerverwaltung_Bestellungen'],
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
]
